import { useMutation } from '@tanstack/react-query';
import { editCreatedAudio } from '../../services';

export function useEditCreatedAudio() {
  return useMutation(editCreatedAudio, { onSuccess: (data) => data });
}
